import React from 'react';
import { ArrowRight, Star, ShieldCheck, Mail } from 'lucide-react';
export function FinalCTA() {
  return <section className="bg-gradient-to-b from-pilates-dark to-pilates-sage-dark py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-68">
      <div className="absolute top-0 left-0 w-96 h-96 bg-pilates-lavender/15 rounded-full blur-3xl" data-id="element-69"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-pilates-cream/10 rounded-full blur-3xl" data-id="element-70"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-71">
        <div className="bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-72">
          One Last Chance
        </div>

        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-tight mb-5 tracking-tight" data-id="element-73">
          Your students deserve the best version of you, not an{' '}
          <span className="italic text-pilates-cream" data-id="element-74">exhausted one</span>.
        </h2>

        <p className="text-white/85 text-lg mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-75">
          Stop spending your Sundays planning. Take back control of your career
          with elite tools.
        </p>

        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 mb-6 max-w-sm mx-auto" data-id="element-76">
          <p className="text-white/80 text-sm mb-2" data-id="element-77">
            Pack 6-in-1: Pilates Ready + 5 Luxury Bonuses
          </p>
          <p className="text-white/70 text-sm mb-1" data-id="element-78">
            <span className="line-through" data-id="element-79">$97 USD</span>
          </p>
          <p className="text-white/85 text-sm mb-1" data-id="element-80">Only:</p>
          <p className="font-display text-6xl sm:text-7xl font-semibold text-pilates-cream leading-none" data-id="element-81">
            $27 USD
          </p>
        </div>

        <a href="https://pilates-ready.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-base sm:text-lg py-4 px-8 sm:px-12 rounded-full shadow-[0_15px_40px_rgba(201,123,99,0.5)] hover:shadow-[0_20px_50px_rgba(201,123,99,0.7)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-82">
          <span data-id="element-83">🚀 YES, I WANT MY PILATES READY PACK</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-84" />
        </a>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-85">
          <div className="flex items-center gap-2 text-white/85 text-sm" data-id="element-86">
            <Mail className="w-4 h-4 text-pilates-cream" data-id="element-87" />
            <span data-id="element-88">Immediate Access — Delivered by Email</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-89">
            <div className="flex text-pilates-cream" data-id="element-90">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-91" />)}
            </div>
            <span className="text-white/90 text-sm font-medium" data-id="element-92">
              4.9/5 — Verified Professional Reviews
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm" data-id="element-93">
            <ShieldCheck className="w-4 h-4 text-pilates-cream" data-id="element-94" />
            <span data-id="element-95">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}